/* Place the existing, configured category navigation in the AZA desktop toolbar.
   Reparents (never clones) the block, preserving exact collection URLs/settings.
   When viewport returns to mobile, returns it to its original position. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-collection')) return;
  var nav, anchor;
  function arrange() {
    var toolbar = document.querySelector('.collection-grid__wrapper > .collection-filter');
    if (!toolbar) return;
    if (!nav || !nav.isConnected) {
      nav = document.querySelector('.seerat-collection-category-chips:not(.seerat-aza-toolbar-chips)');
      if (!nav) return;
      anchor = document.createComment('Original collection chip position');
      nav.parentNode.insertBefore(anchor, nav);
    }
    if (window.matchMedia('(min-width: 769px)').matches) {
      var sort = toolbar.querySelector('.collection-filter__item--sort');
      if (nav.parentNode !== toolbar) toolbar.insertBefore(nav, sort || null);
      nav.classList.add('seerat-aza-toolbar-chips');
      var parent = anchor && anchor.parentElement;
      /* Hide only an otherwise empty source section, not the entire parent tree. */
      if (parent && parent !== toolbar) parent.classList.add('seerat-aza-chips-source');
    } else {
      nav.classList.remove('seerat-aza-toolbar-chips');
      if (anchor && anchor.parentNode && nav.nextSibling !== anchor) anchor.parentNode.insertBefore(nav, anchor.nextSibling);
      if (anchor && anchor.parentElement) anchor.parentElement.classList.remove('seerat-aza-chips-source');
    }
  }
  document.addEventListener('DOMContentLoaded', arrange);
  window.addEventListener('resize', arrange, {passive:true});
  document.addEventListener('shopify:section:load', arrange);
  /* Collection AJAX can replace the toolbar: reattach the existing nav when needed. */
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; arrange(); });
  }).observe(document.body, {childList:true, subtree:true});
})();
